import { CountryFlagCircle } from '@/shared/components/CountryFlagCircle'

type RegionalCoverageCountryCardProps = {
  flag: string
  isoCode?: string
  name: string
  /** Kept for call-site compatibility (stagger was motion-only). */
  gridIndex?: number
}

export function RegionalCoverageCountryCard({
  flag,
  isoCode,
  name,
}: RegionalCoverageCountryCardProps) {
  return (
    <div className="rounded-xl bg-white p-6 text-center shadow-md transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-lg">
      <div className="mb-3 flex w-full justify-center">
        <CountryFlagCircle
          isoCode={isoCode}
          emojiFallback={flag}
          size="compact"
          alt={`${name} flag`}
        />
      </div>
      <div className="text-sm font-semibold text-gray-900">{name}</div>
    </div>
  )
}
